import * as styles from "../styles"


export const Row = ({children, styleOverride = {}, ...props}) => <div style={{...styles.fr, ...styleOverride}} {...props}>{children}</div>

export const Column = ({children, styleOverride = {}, ...props}) => <div style={{...styles.fc, ...styleOverride}} {...props}>{children}</div>